/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerStop = createReactComponent("player-stop", "IconPlayerStop", [
  [
    "path",
    {
      d: "M5 5m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ]
]);

export { IconPlayerStop as default };
//# sourceMappingURL=IconPlayerStop.js.map
